import { Nullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface AttachmentsListModalDetailState {
    label: Nullable<string>
    caseId: Nullable<number>
    sampleId: Nullable<number>
    portionId: Nullable<number>
    subportionId: Nullable<number>
    attachments: any[]
    laboratoryId: number
}
export const initialAttachmentsListModalDetailState =
    (): AttachmentsListModalDetailState => ({
        label: null,
        caseId: null,
        sampleId: null,
        portionId: null,
        subportionId: null,
        attachments: [],
        laboratoryId: store.getters.labId
    })
